<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow">
        <v-btn color="#f57304" big @click="descargarManual()"> 
            <v-icon>fas fa-file-pdf</v-icon> DESCARGAR MANUAL
        </v-btn>
    </v-container>
</template>
<style>
    .grupo-botones {
      display: none;
      margin-top: 10px;
    }

    .boton {
      padding: 10px 20px;
      margin-right: 5px;
    }

  </style>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";
export default {

    data:function(){
        return {

        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"])
    },
    async mounted(){

    },
    methods:{
        descargarManual(){
            window.open(this.baseUrl + "download-manual-asignaciones?token="+this.token,"_blank");
        },
    }
}
</script>
